const FIELD = 'input, textarea, select, button';

/** Переводит фокус на поле формы: узел Mantine с `data-path` либо сам элемент ввода, либо обёртка вокруг него. */
export function focusField(node: HTMLElement | null): void {
  const target = node?.matches(FIELD) ? node : node?.querySelector<HTMLElement>(FIELD);
  target?.focus();
  target?.scrollIntoView?.({ block: 'center' });
}

/** Фокус на первое по порядку на экране поле с ошибкой. `errors` — ошибки из `form.onSubmit`. */
export function focusFirstError(root: HTMLElement | null, errors: Record<string, unknown>): void {
  const fields = root?.querySelectorAll<HTMLElement>('[data-path]') ?? [];
  focusField(Array.from(fields).find((node) => errors[node.dataset.path ?? '']) ?? null);
}

/**
 * Перевести фокус на элемент формы по идентификатору и показать его. Если элемент сам фокус не принимает (раздел,
 * группа переключателей), фокус получает первое доступное поле внутри него. Так сводка ошибок ведёт к полю.
 */
export function focusFieldById(id: string): void {
  const element = document.getElementById(id);
  if (!element) {
    return;
  }
  // Заблокированное поле фокус не принимает: тогда только показываем его.
  const focusable = element.matches('input, textarea, button, select, [tabindex]')
    ? element
    : element.querySelector<HTMLElement>('input:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="-1"]');
  if (focusable && !focusable.matches(':disabled')) {
    focusable.focus({ preventScroll: true });
  }
  element.scrollIntoView?.({ block: 'center', behavior: 'auto' });
}
